/* eslint-disable newline-per-chained-call */
/* eslint-disable newline-before-return */
/* eslint-disable newline-after-var */
/* eslint-disable new-cap */
/* eslint-disable n/handle-callback-err */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
/* eslint-disable no-new */
/* eslint-disable no-return-assign */
/* eslint-disable dot-notation */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/extensions */
import React, { useContext } from 'react';
import { API, Auth, Storage } from 'aws-amplify';
import { Country, State } from 'country-state-city';
import { styled } from '@mui/material/styles';
import { autocompleteClasses } from '@mui/material/Autocomplete';
import { toast } from 'react-toastify';
import { LanguageContext } from './Context';
import axios from 'axios';
import format from 'date-fns/format';
import html2canvas from 'html2canvas';
import pako from 'pako';
import Compressor from 'compressorjs';
import Resizer from 'react-image-file-resizer';
import en from '../locale/en.json';
import hi from '../locale/hi.json';
import sp from '../locale/sp.json';
import it from '../locale/it.json';
import fr from '../locale/fr.json';
import pt from '../locale/pt.json';

const newWindow:any = window;
const PDFJS = newWindow.pdfjsLib;

export const queryParams = (uuid:any, comId:any, empRole:any, role:any, method:any) =>
{
	let query = '';

	if (uuid !== '' && method === 'get')
	{
		query += `&uid=${uuid}`;
	}
	else if (uuid !== '')
	{
		query += `?uid=${uuid}`;
	}

	if (comId)
	{
		query += `&comid=${comId}`;
	}

	if (empRole)
	{
		query += `&empRole=${empRole}`;
	}

	if (role)
	{
		query += `&role=${role}`;
	}

	return query;
};

export const userInfo = (userData:any) =>
{
	return { firstName: userData?.firstName, profileImage: userData?.profileImage, industryTypes: userData?.industryTypes, companyName: userData?.companyName, thumbnailImage: userData?.thumbnailImage };
};

export function generateRandomUUID()
{
	let id = '';

	while (id.length < 20)
	{
		id += Math.random().toString(36)
			.substring(2);
	}

	return id.substring(0, 20);
}
export const getSocketSessionId = (storageKey = 'sessionId') =>
{
	const existing = localStorage.getItem(storageKey);

	if (existing)
	{
		return existing;
	}

	const newId = generateRandomUUID();

	localStorage.setItem(storageKey, newId);

	return newId;
};
export const dateFormatDDMMMYYYYHHMM = (dateRes) => // 12 Dec 2024, 12:23 PM
{
	const date = new Date(dateRes);

	const options:any = {
		day    : '2-digit',
		month  : 'short',
		year   : 'numeric',
		hour   : '2-digit',
		minute : '2-digit',
		hour12 : true
	};

	const formattedDate = date.toLocaleString('en-In', options);

	return formattedDate;
};

export function dateFormat(date:any)
{
	return new Date(date).toLocaleString('en-IN', {
		day   : '2-digit',
		month : '2-digit',
		year  : 'numeric'
	});
}

export function dateFormatMonth(date:any)
{
	return new Date(date).toLocaleString('en-IN', {
		day   : '2-digit',
		month : 'short',
		year  : 'numeric'
	});
}

export function dateFormatMonthBPS(date:any)
{
	return new Date(date).toLocaleString('en-IN', {
		day   : '2-digit',
		month : 'short',
		year  : 'numeric'
	})
		.replace(/-/g, ' ');
}

export function monthDateYearFormate(date:any, monthType)
{
	return new Date(date).toLocaleString('en-US', {
		day   : 'numeric',
		month : monthType,
		year  : 'numeric'

	})
		.replace(/-/g, ' ');
}

export function MonthDate(date:any)
{
	return new Date(date).toLocaleString('en-US', {
		month : 'short', // Short month name like 'Sept'
		day   : 'numeric' // Day of the month

	})
		.replace(/-/g, ' ');
}
export function HHMMFotmate(timestamp)
{
	const date = new Date(timestamp);

	return date.toLocaleTimeString('en-US', {
		hour   : 'numeric',
		minute : '2-digit',
		hour12 : true
	});
}

export function dateTime(date:any)
{
	return new Date(date).toLocaleString('en-US', {
		day    : '2-digit',
		month  : 'short',
		year   : 'numeric',
		hour   : '2-digit',
		minute : '2-digit',
		hour12 : true
	})
		.replace(',', '');
}

export function formatTimeRange(startTimeStamp, endTimeStamp)
{
	const startDate = new Date(startTimeStamp);
	const endDate = new Date(endTimeStamp);

	// Function to format time to 12-hour clock with AM/PM
	const formatTime = (date) =>
	{
		return date.toLocaleString('en-US', {
			hour   : 'numeric',
			minute : 'numeric',
			hour12 : true
		});
	};

	// Calculate the difference in milliseconds
	const diffMs = endTimeStamp - startTimeStamp;

	// Convert the difference to minutes
	const diffMins = Math.floor(diffMs / 60000); // Convert ms to minutes
	const hours = Math.floor(diffMins / 60); // Calculate hours
	const minutes = diffMins % 60; // Calculate remaining minutes

	// Format the time range and duration
	const timeRange = `${formatTime(startDate)} to ${formatTime(endDate)}`;
	const duration = `${hours}hr ${minutes}mins`;

	return `${timeRange} - ${duration}`;
}

export function timeFormat(date:any)
{
	return new Date(date).toLocaleString('en-US', {
		hour   : '2-digit',
		minute : '2-digit',
		hour12 : true
	});
}

export function datetimeFormat(date:any)
{
	return new Date(date).toLocaleString('en-IN', {
		day    : '2-digit',
		month  : '2-digit',
		year   : 'numeric',
		hour   : '2-digit',
		minute : '2-digit',
		second : '2-digit',
		hour12 : true
	});
}

export function userFullName(userData:any)
{
	const fullName = userData.firstName
		? userData.lastName
			? `${userData.firstName} ${userData.lastName}`
			: `${userData.firstName}`
		: userData?.name
			? `${userData.name}`
			: userData?.fullname
				? `${userData.fullname}`
				: '';

	return fullName;
}

export const configuration =
		{
			iceServers : [
				{
					urls : [
						'stun:stun1.l.google.com:19302',
						'stun:stun2.l.google.com:19302'
					]
				}
			],
			iceCandidatePoolSize : 10
		};

export const getContraints = (type) =>
{
	if (type === 'audio')
	{
		return { video: false, audio: { sampleRate: 16000, channelCount: 1, volume: 1.0, echoCancellation: true } };
	}
	else
	{
		return { video: true, audio: { sampleRate: 16000, channelCount: 1, volume: 1.0, echoCancellation: true } };
	}
};

export const openMediaDevices = async (constraints) =>
{
	return await navigator.mediaDevices.getUserMedia(constraints);
};

export const catchErr = (e:any) =>
{
	if (e?.response?.data?.error)
	{
		toast.error(e?.response?.data?.error, {
			position  : toast.POSITION.TOP_RIGHT,
			className : 'toast-message'
		});
	}
	else if (e?.response?.data?.message)
	{
		toast.error(e?.response?.data?.message, {
			position  : toast.POSITION.TOP_RIGHT,
			className : 'toast-message'
		});
	}
	else
	{
		toast.error(e?.message, {
			position  : toast.POSITION.TOP_RIGHT,
			className : 'toast-message'
		});
	}
};

export const s3Delete = (key:string, type) =>
{
	// use s3DeleteNew instead of this function
	Storage.configure({
		bucket       : process.env.REACT_APP_S3_BUCKET,
		region       : process.env.REACT_APP_S3_BUCKET_REGION,
		customPrefix : {
			public : `${process.env.REACT_APP_STAGE}/${type}/`
		}
	});

	return Storage.remove(key);
};
export const s3DeleteFrmInmeet = (key) =>
{
	Storage.configure({
		bucket       : process.env.REACT_APP_INMEET_S3_BUCKET,
		region       : process.env.REACT_APP_INMEET_S3_REGION,
		customPrefix : { public: '' }
	});

	return Storage.remove(key);
};
export const s3DeleteNew = (key:string, type) =>
{
	Storage.configure({
		bucket       : process.env.REACT_APP_S3_BUCKET,
		region       : process.env.REACT_APP_S3_BUCKET_REGION,
		customPrefix : { public: '' }
	});

	return Storage.remove(key);
};

export const s3ExistOrNot = async (key:string) =>
{
	Storage.configure({
		bucket : process.env.REACT_APP_S3_BUCKET,
		region : process.env.REACT_APP_S3_BUCKET_REGION
	});
	const exist = await Storage.get(key);

	return exist;
};

export const s3MutipleDelete = async (multipleKeys:any, type:any = 'public') =>
{
	if (type === 'public')
	{
		Storage.configure({
			bucket : process.env.REACT_APP_S3_BUCKET,
			region : process.env.REACT_APP_S3_BUCKET_REGION
		});
	}
	else
	{
		Storage.configure({
			bucket       : process.env.REACT_APP_S3_BUCKET,
			region       : process.env.REACT_APP_S3_BUCKET_REGION,
			customPrefix : {
				public : `${type}/`
			}
		});
	}
	let delResult;

	for (let i = 0; i < multipleKeys.length; i++)
	{
		delResult = await Storage.remove(multipleKeys[i]);
	}

	return delResult;
};

export const DateDiff = (dateFuture: number, dateNow: number) =>
{
	const { language } = useContext(LanguageContext);
	const diffInMilliSeconds = Math.abs(dateFuture - dateNow);
	const days = Math.floor(diffInMilliSeconds / 86400000);

	if (days > 365)
	{
		const years = Math.floor(days / 365);

		return `${years} ${years > 1 ? language?.yearsAgo : language?.yearAgo}`;
	}

	if (days > 30)
	{
		const months = Math.floor(days / 30);

		return `${months} ${months > 1 ? language?.monthsAgo : language?.monthAgo}`;
	}

	if (days > 0)
	{
		return `${days} ${days > 1 ? language?.daysAgo : language?.dayAgo}`;
	}

	const minutes = Math.floor(diffInMilliSeconds / 60000);

	if (minutes > 59)
	{
		const hours = Math.floor(minutes / 60);

		return `${hours} ${hours > 1 ? language?.hrsAgo : language?.hrAgo}`;
	}

	if (minutes > 0)
	{
		return `${minutes} ${minutes > 1 ? language?.minsAgo : language?.minuteAgo}`;
	}

	return language?.justAgo;
};

const checkType = (file:any) =>
{
	if (file?.includes('video'))
	{
		return 'VIDEO';
	}
	else if (file?.includes('image'))
	{
		return 'IMG';
	}
	else
	{
		return 'FILE';
	}
};

/**
 * Get Thumbnail
 */
export const getVideoThumbnail = async (file:any) =>
{
	return new Promise((resolve, reject) =>
	{
		const fileReader = new FileReader();

		fileReader.onload = (e:any) =>
		{
			const blob = new Blob([ e.target.result ], { type: file.type });
			const url = URL.createObjectURL(blob);
			const video = document.createElement('video');

			const snapImage = function()
			{
				const canvas = document.createElement('canvas');

				canvas.width = video.videoWidth;
				canvas.height = video.videoHeight;
				const context = canvas.getContext('2D') as CanvasRenderingContext2D | null;

				if (context)
				{
					context.drawImage(video, 0, 0, canvas.width, canvas.height);
					const image = canvas.toDataURL();
					const success = image.length > 100000;

					if (success)
					{
						resolve(image);
					}

					return success;
				}
			};

			const timeupdate = function()
			{
				if (snapImage())
				{
					video.removeEventListener('timeupdate', timeupdate);
					video.pause();
				}
			};

			video.addEventListener('loadeddata', function()
			{
				if (snapImage())
				{
					video.removeEventListener('timeupdate', timeupdate);
				}
			});

			video.addEventListener('timeupdate', timeupdate);
			video.preload = 'metadata';
			video.src = url;

			// Load video in Safari / IE11
			video.muted = true;
			video.playsInline = true;
			video.play();
		};
		fileReader.readAsArrayBuffer(file);
		fileReader.onerror = (error) =>
		{
			reject(error);
		};
	});
};

/**
 * Get Duration
 */
export const getVideoDuration = async (file: any) =>
{
	return new Promise((resolve, reject) =>
	{
		const videoElement = document.createElement('video');

		// Function to handle error and cleanup
		const handleError = (error: any) =>
		{
			videoElement.onerror = null;
			reject(error);
		};

		// Check if file has a URL (cloud video)
		if (file.url)
		{
			videoElement.src = file.url;
		}
		else
		{
			// For local files, use FileReader to convert to a data URL
			const reader = new FileReader();

			reader.onload = (e: any) =>
			{
				videoElement.src = e.target.result;
			};

			reader.onerror = (error) => handleError(error);
			reader.readAsDataURL(file);
		}

		// Video metadata loaded successfully
		videoElement.onloadedmetadata = () =>
		{
			const duration = Math.floor(videoElement.duration * 1000);

			resolve(duration);
		};

		// Error handler for video loading issues
		videoElement.onerror = (error) => handleError(error);
	});
};

export const sanitizeFileName = (fileName: string, maxBaseLength = 50) =>
{
	// Extract the base name and extension
	const lastDotIndex = fileName.lastIndexOf('.');
	const baseName = lastDotIndex !== -1 ? fileName.slice(0, lastDotIndex) : fileName;
	const extension = lastDotIndex !== -1 ? fileName.slice(lastDotIndex) : '';

	// Sanitize: remove unsafe chars and replace spaces with underscores
	const cleanedBase = baseName
		.replace(/[^a-zA-Z0-9\-_ ]/g, '') // remove special chars (keep - _ and space)
		.replace(/\s+/g, '_') // replace space with underscore
		.toLowerCase();

	// Truncate the base name if it's too long
	const truncatedBase = cleanedBase.slice(0, maxBaseLength);

	// Combine and return sanitized file name
	return `${truncatedBase}${extension.toLowerCase()}`;
};

export const ChatUploadFiles = async (file:any, type:string) =>
{
	Storage.configure({
		bucket : process.env.REACT_APP_S3_BUCKET,
		region : process.env.REACT_APP_S3_BUCKET_REGION
	});

	const resultArray:any = [];

	for (let i = 0; i < file.length; i++)
	{
		const customPrefix:any = { public: `${type}/` };

		const sanitizedKey = sanitizeFileName(Date.now() + file[i].name);

		const result:any = await Storage.put(sanitizedKey, file[i], { customPrefix, contentType: file.type });

		resultArray.push({
			url         : `${process.env.REACT_APP_S3_BASE_URL}/${type}/${result.key}`,
			type        : file[i].type,
			key         : `${type}/${result.key}`,
			message     : '',
			messageType : checkType(file[i].type),
			refId       : generateRandomUUID(),
			title       : file[i].name,
			name        : file[i].name
		});
	}

	return resultArray;
};

export const s3FileUpload = async (file:any, type:string) =>
{
	console.log('s3FileUpload----------------->>>', '\n file:', file, '\n type:', type);
	Storage.configure({
		bucket : process.env.REACT_APP_S3_BUCKET,
		region : process.env.REACT_APP_S3_BUCKET_REGION
	});

	const sanitizedKey = sanitizeFileName(Date.now() + file.name);

	try
	{
		if (type === 'public')
		{
			const result = await Storage.put(sanitizedKey, file, {
				contentType : file.type
			});

			return {
				url  : `${process.env.REACT_APP_S3_BASE_URL}/public/${result.key}`,
				type : file.type,
				key  : result.key,
				name : file.name.replace(/ /g, '_')
			};
		}
		else
		{
			const customPrefix:any = { public: `${type}/` };

			const result = await Storage.put(sanitizedKey, file, {
				contentType : file.type,
				customPrefix
			});

			return {
				url  : `${process.env.REACT_APP_S3_BASE_URL}/${type}/${result.key}`,
				type : file.type,
				key  : `${type}/${result.key}`,
				name : file.name.replace(/ /g, '_')
			};
		}
	}
	catch (err)
	{
		return err;
	}
};

export const newUploadFiles = async (file:any, type:string) =>
{
	Storage.configure({
		bucket : process.env.REACT_APP_S3_BUCKET,
		region : process.env.REACT_APP_S3_BUCKET_REGION
	});

	const resultArray:any = [];

	for (let i = 0; i < file.length; i++)
	{
		type = type !== '' ? type : 'public';

		const sanitizedKey = sanitizeFileName(`${Date.now()}_${file[i].name}`);
		const customPrefix = { public: `${type}/` };
		const result:any = await Storage.put(sanitizedKey, file[i], { customPrefix, contentType: file.type });

		const obj:any = {
			url   : `${process.env.REACT_APP_S3_BASE_URL}/${type}/${result.key}`,
			type  : file[i].type,
			key   : `${type}/${result.key}`,
			title : result.key,
			name  : file[i]?.name?.replace(/ /g, '_'),
			size  : file[i].size
		};

		if (file[i]?.type.split('/')[0] === 'video')
		{
			// const duration = await getVideoDuration(file[i]);
			const thumbnails = await getVideoThumbnail(file[i]);

			// obj.duration = duration;
			obj.thumbnail = thumbnails;
		}

		resultArray.push(obj);
	}

	return resultArray;
};

export const newNewsFeedUploadFiles = async (file:any, type:string) =>
{
	Storage.configure({
		bucket : process.env.REACT_APP_S3_BUCKET,
		region : process.env.REACT_APP_S3_BUCKET_REGION
	});

	const resultArray:any = [];

	for (let i = 0; i < file?.length; i++)
	{
		type = type !== '' ? type : 'public';
		const sanitizedKey = sanitizeFileName(`${new Date().valueOf()}${file[i]?.name}`);
		const customPrefix = { public: `${type}/` };
		const result:any = await Storage.put(sanitizedKey, file[i], { customPrefix, contentType: file?.type });

		resultArray.push({
			url  	: `${process.env.REACT_APP_S3_BASE_URL}/${type}/${result?.key}`,
			type  : file[i]?.type,
			key   : `${type}/${result?.key}`,
			title : result?.key,
			name  : file[i]?.name.replace(/ /g, '_'),
			size 	: file[i]?.size
		});
	}

	return resultArray;
};

export const Formatter = (num:any) =>
{
	if (num >= 1000000000)
	{
		return `${(num / 1000000000).toFixed(1).replace(/\.0$/, '')}T`;
	}
	if (num >= 1000000)
	{
		return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
	}
	if (num >= 1000)
	{
		return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
	}

	return num.toFixed(1).replace(/\.0$/, '');
};
export function getCountryName(code)
{
	const cData:any = Country.getCountryByCode(code);

	return cData?.name ? cData.name : '';
}
export function getStateName(stateCode, countryCode)
{
	const sData:any = State.getStateByCodeAndCountry(stateCode, countryCode);

	return sData?.name ? sData.name : '';
}

export function DiffWeeks(Week:any)
{
	const currentDate:any = new Date();
	const startDate:any = new Date(currentDate.getFullYear(), 0, 1);
	const days:any = Math.floor((currentDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000));
	const weekNumber:any = Math.ceil(days / 7);
	const weekDifference = weekNumber - Week;
	const { language } = useContext(LanguageContext);

	if (weekDifference >= 4) return language?.fourWeekAgo;
	if (weekDifference === 3) return language?.threeWeekAgo;
	if (weekDifference === 2) return language?.twoWeekAgo;
	if (weekDifference === 1) return language?.lastWeekCaps;

	return language?.recentCaps;
}

export function getMonthName(monthNumber)
{
	const date = new Date();

	date.setMonth(monthNumber - 1);

	return date.toLocaleString('en-US', { month: 'short' });
}

export function downLoadFiles(url, title)
{
	const href = url;
	const link = document.createElement('a');

	link.href = href;
	link.setAttribute('download', title); // or any other extension
	// link.setAttribute('target', '_blank'); // or any other extension
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export async function downLoadFilesFromS3(key, name)
{
	try
	{
		const inMeetUrl = ['development', 'testing'].includes(process.env.REACT_APP_STAGE || '') ?? false // for dev and test env we have to use inmeet url for collaboration
		await Storage.configure({
			bucket       :  inMeetUrl ? process.env.REACT_APP_INMEET_S3_BUCKET : process.env.REACT_APP_S3_BUCKET,
			customPrefix : {
				public : ''
			},
			region : inMeetUrl ? process.env.REACT_APP_INMEET_S3_REGION : process.env.REACT_APP_S3_BUCKET_REGION
		});

		const uploadResult:any = await Storage.get(key, { download: true });
		const objUrl = URL.createObjectURL(uploadResult?.Body);
		const a = document.createElement('a');

		a.href = objUrl;
		a.download = name;
		const clickHandler = () =>
		{
			setTimeout(() =>
			{
				URL.revokeObjectURL(objUrl);
				a.removeEventListener('click', clickHandler);
			}, 150);
		};

		a.addEventListener('click', clickHandler, false);
		a.click();
	}
	catch (err)
	{
		catchErr(err);
	}
}

export function formatBytes(bytes:any, decimals = 2)
{
	if (!Number(bytes)) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = [ 'Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB', 'RB', 'QB' ];

	const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(k));

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export function extractYoutubeUrlAndString(text:any)
{
	const youtubeUrlRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([a-zA-Z0-9-_]+)/g;
	const match = youtubeUrlRegex.exec(text);

	if (!match) return { url: null, string: text };
	const url = match[0];
	const index = match.index;
	const string = text.slice(0, index) + text.slice(index + url.length);

	return { url, string };
}

export function roleCondition(empRole:any)
{
	if (empRole && (empRole === 'superAdmin' || empRole === 'admin'))
	{
		return true;
	}
	else
	{
		return false;
	}
}

export function canAccessBusinessProspects(userData:any, accessConfigs:any)
{
	// Admins and super admins have full access
	if (roleCondition(userData?.empRole))
	{
		return true;
	}

	// For employees, check if they are sales employees OR have companyCount > 0
	if (userData?.empRole === 'employee')
	{
		return accessConfigs?.prospectsAccess?.salesEmp || (userData?.companyCount > 0);
	}

	// Default: no access
	return false;
}

export function axiosApiCall(method, sub, url, body)
{
	return axios({
		method,
		headers : { sub },
		url,
		data    : JSON.stringify(body)
	});
}

export const convertSecToHHMM = (dur) =>
{
	let m = 0;
	let h = 0;

	if (dur < 1)
	{
		m = dur * 60;
		m = Math.round(m);
	}
	else
	{
		h = Math.floor(dur);
		m = (dur - h) * 60;
		m = Math.round(m);
	}

	return (dur > 0) ? ((dur < 1) ? `${m} min` : `${h} hr ${m} min`) : '0';
};

/**
 * Convert seconds to a proper time display format
 * @param seconds - Number of seconds to convert
 * @returns Formatted time string in short format (e.g., "1h 30m", "45s")
 */
export const convertSecondsToTimeDisplay = (seconds: number): string =>
{
	if (!seconds || seconds < 0) return '0s';

	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = Math.floor(seconds % 60);

	if (hours > 0)
	{
		return `${hours}h ${minutes}m`;
	}
	else if (minutes > 0)
	{
		return `${minutes}m ${remainingSeconds}s`;
	}
	else
	{
		return `${remainingSeconds}s`;
	}
};

export const getHHMMSSForamt = (time) =>
{
	const date = new Date(time);
	const hours = date.getUTCHours();
	const minutes = date.getUTCMinutes();
	const seconds = date.getUTCSeconds();

	let value = `${seconds} sec`;

	if (minutes > 0)
	{
		value = `${minutes}min ${value}`;
	}
	if (hours > 0)
	{
		value = `${hours}min ${value}`;
	}

	return value;
};

export const getCallEvent = (message, sentBy, session, userName) =>
{
	const { language } = useContext(LanguageContext);

	const at = ` at ${timeFormat(message.createdAt)}`;

	if (message.message === 'missed video')
	{
		return sentBy === session.userId ? language?.youCancelVCall + at : language?.youmissedVcall + at;
	}
	else if (message.message === 'missed audio')
	{
		return sentBy === session.userId ? language?.youcancelAcall + at : language?.youmissedAcall + at;
	}
	else if (message.message === 'no answer audio')
	{
		return sentBy === session.userId ? `${userName} not answered an audio call ${at}` : language?.youmissedAcall + at;
	}
	else if (message.message === 'no answer video')
	{
		return sentBy === session.userId ? `${userName} not answered a video call ${at}` : language?.youmissedAcall + at;
	}
	else if (message.message === 'decline audio')
	{
		return sentBy === session.userId ? `${userName} ${language?.declinedAudio}${at}` : language?.youdeclinedAcall + at;
	}
	else if (message.message === 'decline video')
	{
		return sentBy === session.userId ? `${userName} ${language?.declinedvideo}${at}` : language?.youdeclinedVcall + at;
	}
	else if (message.message === 'accept audio')
	{
		return `${language?.audioCall} ${getHHMMSSForamt(message.updatedAt - message.createdAt)}${at}`;
	}
	else if (message.message === 'accept video')
	{
		return `${language?.videoCall} ${getHHMMSSForamt(message.updatedAt - message.createdAt)}${at}`;
	}
	else if (message.message === 'busy')
	{
		return sentBy === session.userId ? `${userName} ${language?.isanother}` : language?.youmissedcall + at;
	}
	else if (message.message === 'group audio')
	{
		return sentBy !== session.userId ? `${userName} ${language?.startAcall}${at}` : language?.youstartAcall + at;
	}
	else if (message.message === 'group video')
	{
		return sentBy !== session.userId ? `${userName} ${language?.startVcall}${at}` : language?.youstartVcall + at;
	}

	return message.message;
};

export const renderDate = (chat, dates) =>
{
	const timestampDate = format(chat, 'EEEE, dd/MM/yyyy');

	dates.add(timestampDate);

	return timestampDate;
};

export const fetchDiffInDays = (data:number) =>
{
	const date = new Date(data).setHours(0, 0, 0, 0);

	const diffInDays = (date - new Date().valueOf()) / 86400000;

	return Math.ceil(diffInDays);
};

export const fetchCurrFormat = (region:any, curr:any, price:any) =>
{
	const money = new Intl.NumberFormat(region, {
		style                 : 'currency',
		currency              : curr || 'INR',
		maximumFractionDigits : 0,
		minimumFractionDigits : 0
	}).format(price);

	return money;
};

export function followType(roleType:any, companyFollow:any, individualFol:any)
{
	if (roleType === 'superAdmin' || roleType === 'admin')
	{
		return companyFollow;
	}
	else
	{
		return individualFol;
	}
}

export function duplicateRelation(networkRelations:any)
{
	return	networkRelations.filter((item:any) => !item?.relation.includes('of'));
}

export function duplicateArrayObject(arrayData:any)
{
	return	arrayData.filter((item:any, index) => arrayData?.indexOf(item?._id) === index);
}

export const getYoutubeInfo = async (urlItem: any) =>
{
	try
	{
		const data = await fetch(`https://www.youtube.com/oembed?url=${urlItem}&format=json`);

		const res = await data.json();

		return res;
	}

	catch (err)
	{
		console.log(err);
	}
};

export const getProfileImage = (thumbnailImage:any, profileImage:any) =>
{
	const checkThumbnailImage:any = thumbnailImage === '' || thumbnailImage === 'null' || thumbnailImage === null || thumbnailImage === undefined;
	const checkProfileImage:any = profileImage === '' || profileImage === 'null' || profileImage === null || profileImage === undefined;

	const image:any = !checkThumbnailImage ? thumbnailImage : !checkProfileImage ? profileImage : '/images/icons/defaultUser.svg';

	return image;
};

export const checkSuperAdmin = (empRole:any) =>
{
	if (empRole && (empRole === 'superAdmin'))
	{
		return true;
	}
	else
	{
		return false;
	}
};

export function isTouchDevice()
{
	return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
}

export const updateCounts = (array1:any, array2:any) =>
{
	const arr:any = [];

	for (let i = 0; i < array1.length; i++)
	{
		const matchedObject = array2.find((obj:any) => obj?.id === array1.length - 1);

		array1[i].sectionMedia = (matchedObject) ? matchedObject.media : [];

		arr.push(array1[i]);
	}

	return arr;
};

export const convertMillisecondsToHHMMSS = (milliseconds) =>
{
	const getDuration = (val:any) =>
	{
		return String(Math.floor(val)).padStart(2, '0');
	};
	const seconds = Math.floor(milliseconds / 1000);

	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = seconds % 60;

	const formattedHours = getDuration(hours);
	const formattedMinutes = getDuration(minutes);
	const formattedSeconds = getDuration(remainingSeconds);

	const formattedTime = `${hours >= 1 ? `${formattedHours}:` : ''}${formattedMinutes}:${formattedSeconds}`;

	return formattedTime;
};

export const stringDateFormate = (date) =>
{
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const day = date.getDate().toString()
		.padStart(2, '0');

	const formattedDate = `${year}-${month}-${day}`;

	return formattedDate;
};

export const GoogleCalender = (title:any, description:any, startDate:any, endDate:any) =>
{
	const startTimeDetails = () =>
	{
		const today:any = new Date(startDate);
		const year:any = today.getFullYear();
		let month:any = today.getMonth() + 1;

		if (month < 10)
		{
			month = `0${month}`;
		}
		let day = today.getDate();

		if (day < 10)
		{
			day = `0${day}`;
		}

		let hours = today.getHours();

		if (hours < 10)
		{
			hours = `0${hours}`;
		}
		let minutes = today.getMinutes();

		if (minutes < 10)
		{
			minutes = `0${minutes}`;
		}

		return `${year}${month}${day}T${hours}${minutes}00`;
	};

	const endtimeDetails = () =>
	{
		const today:any = new Date(endDate);
		const year:any = today.getFullYear();
		let month:any = today.getMonth() + 1;

		if (month < 10)
		{
			month = `0${month}`;
		}
		let day = today.getDate();

		if (day < 10)
		{
			day = `0${day}`;
		}

		let hours = today.getHours();

		if (hours < 10)
		{
			hours = `0${hours}`;
		}
		let minutes = today.getMinutes();

		if (minutes < 10)
		{
			minutes = `0${minutes}`;
		}

		return `${year}${month}${day}T${hours}${minutes}00`;
	};

	const startTime:any = startTimeDetails();
	const endTime = endtimeDetails();

	const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
		title
	)}&dates=${startTime}/${endTime}&details=${encodeURIComponent(
		description
	)}}`;

	const win:any = window.open(googleCalendarUrl, '_blank');

	win.focus();
};

export const OutlookCalender = (title:any, description:any, startDate:any, endDate:any) =>
{
	const startTime = new Date(startDate);
	const endTime = new Date(endDate);

	const outlookCalendarUrl = `https://outlook.live.com/owa/?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(
		title
	)}&startdt=${startTime.toISOString()}&enddt=${endTime.toISOString()}&body=${encodeURIComponent(description)}`;

	window.open(outlookCalendarUrl, '_blank');
};
export const YahooCalendar = (title: any, description: any, startDate: any, endDate: any) =>
{
	const startTime = new Date(startDate);
	const endTime = new Date(endDate);

	const yahooCalendarUrl = `https://calendar.yahoo.com/?v=60&title=${encodeURIComponent(
		title
	)}&st=${startTime
		.toISOString()
		.replace(/[-:]/g, '')
		.split('.')[0]}Z&et=${endTime
		.toISOString()
		.replace(/[-:]/g, '')
		.split('.')[0]}Z&desc=${encodeURIComponent(description)}`;

	window.open(yahooCalendarUrl, '_blank');
};

export const fileToObjectUrl = (file: File): Promise<string> =>
{
	return new Promise<string>((resolve) =>
	{
		const objectURL = URL.createObjectURL(file);

		resolve(objectURL);
	});
};

export const objectUrlToFile = async (objectUrl: string, fileName: string): Promise<File> =>
{
	const response = await fetch(objectUrl);
	const blob = await response.blob();

	const buffer = await blob.arrayBuffer();

	console.log(new Uint8Array(buffer).slice(0, 16));

	// Create a new File object from the blob
	const file = new File([ blob ], fileName, { type: blob.type });

	return file;
};

export const medaiDriveDateDiff = (customTime:number, currentTime:any = new Date().valueOf()) =>
{
	const currentDate = new Date(customTime);

	currentDate.setHours(0, 0, 0, 0);
	const today = new Date(currentTime);

	today.setHours(0, 0, 0, 0);
	let message = '';

	const isToday = currentDate.getTime() === today.getTime();

	if (!isToday)
	{
		message = new Date(customTime).toLocaleString('en-US', {
			month : 'short',
			day   : '2-digit',
			year  : 'numeric'
		});
	}
	else
	{
		const time = new Date(customTime).toLocaleString('en-IN', {
			hour   : '2-digit',
			minute : '2-digit',
			hour12 : true
		});

		message = `Today, ${time}`;
	}

	return message;
};

export const html2canvasConversation = (preview:any, fileType:any) =>
{
	html2canvas(preview).then(function(canvas)
	{
		const dataURL = canvas.toDataURL(fileType === '.jpg' ? 'image/jpeg' : 'image/png');

		return dataURL;
	});
};

export const dataURLtoFile = (dataurl, fileName) =>
{
	const arr = dataurl.split(',');
	const mime = arr[0].match(/data:([^;]+);base64/)[1];
	const bstr = atob(arr[1]);
	let n = bstr?.length;
	const u8arr = new Uint8Array(n);

	while (n--) u8arr[n] = bstr.charCodeAt(n);

	return new File([ u8arr ], fileName, { type: mime });
};
export const downloadImage = async (img:any, type:any) =>
{
	if (img)
	{
		try
		{
			const response = await fetch(img);
			const blob = await response.blob();

			const imageUrl = window.URL.createObjectURL(blob);
			const link = document.createElement('a');

			link.href = imageUrl;
			link.download = type;
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
		}
		catch (error)
		{
			console.error('Error downloading Blob URL:', error);
		}
	}
};

// Convert imageURL type to JPG
export const imageTypeConvert = (fileData, callback) =>
{
	if (fileData.type === 'image/png')
	{
		callback(fileData);

		return;
	}

	const image = new Image();

	image.onload = () =>
	{
		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');

		if (ctx)
		{
			canvas.width = image.width;
			canvas.height = image.height;
			ctx.fillStyle = '#ffffff';
			ctx.fillRect(0, 0, canvas.width, canvas.height);
			ctx.drawImage(image, 0, 0);
			const newDataUrl = canvas.toDataURL('image/jpeg', 0.4);

			const fileNameWithoutExtension = fileData.name.replace(/\.[^/.]+$/, '');
			const convertedImgData = dataURLtoFile(newDataUrl, `${fileNameWithoutExtension}.jpg`);

			callback(convertedImgData);
		}
		else
		{
			console.log('somthing went wrong!');
		}
	};

	image.src = URL.createObjectURL(fileData);
};

export const createFileFromBlobUrl = async (blobUrl:any, fileName:any, imgType:any) =>
{
	try
	{
		const response = await fetch(blobUrl);
		const blobData = await response.blob();

		const imageType = imgType || 'image/jpeg';

		const file = new File([ blobData ], fileName, { type: imageType });

		return file;
	}
	catch (error)
	{
		console.error('Error creating File from Blob URL:', error);

		return null;
	}
};

const sxObject = {
	overflow            : 'visible',
	filter              : 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
	mt                  : 1.5,
	'& .MuiAvatar-root' : {
		width  : 32,
		height : 32,
		ml     : -0.5,
		mr     : 1
	},
	'&:before' : {
		content   : '""',
		display   : 'block',
		position  : 'absolute',
		top       : 0,
		right     : 14,
		width     : 10,
		height    : 10,
		bgcolor   : 'background.paper',
		transform : 'translateY(-50%) rotate(45deg)',
		zIndex    : 0
	}
};

export const MuiPaperPropsStyles = {
	elevation : 0,
	sx        : sxObject,
	style     : {
		maxHeight : 'var(--font200)', // Set a maximum height for the Menu
		overflowY : 'auto'
	}
};

export const MuiPaperProps = {
	elevation : 0,
	sx        : sxObject
};

export const handleFileUpload = (e, type, ImgType, data, language, files, status) =>
{
	for (const file of e.target.files)
	{
		if (type === 'image' && !ImgType?.includes(file.type))
		{
			toast.error(language.supportImagetypefiles, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
		else
		{
			if (status === 'uploadresource')
			{
				data?.url && s3DeleteNew(data?.key, 'resource');
			}
			files.push(file);
		}
	}
};

export const InputWrapper = styled('div')(
	({ theme }) => `
  width: 100%;
  border: 1px solid ${theme.palette.mode === 'dark' ? '#434343' : 'var(--whiteD9)'};
  background-color: ${theme.palette.mode === 'dark' ? '#141414' : 'var(--whiteColor)'};
  border-radius: 13px;
  padding: 1px;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#000000'};
  }

  &.focused {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    background-color: ${theme.palette.mode === 'dark' ? '#141414' : 'var(--whiteColor)'};
    color: ${
	theme.palette.mode === 'dark'
		? 'rgba(255,255,255,0.65)'
		: 'rgba(0,0,0,.85)'
};
    height: 40px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`
);

export const Listbox = styled('ul')(
	({ theme }) => `
  width:100% ;
  margin: 2px 0 0;
  padding: 0;
//   position: absolute;
  list-style: none;
  background-color: ${theme.palette.mode === 'dark' ? '#141414' : 'var(--whiteColor)'};
//   background-color:"ffffff"
  overflow: auto;
  max-height: 250px;
  border-radius: 13px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
//   z-index: 222222;

  & li {
    padding: 5px var(--pixel12);
    display: flex;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    //   color:red
    }
  }

  & li[aria-selected='true'] {
    background-color: ${theme.palette.mode === 'dark' ? '#2b2b2b' : '#fafafa'};
    font-weight: 600;

    & svg {
      color: #1890ff;
    }
  }

  & li.${autocompleteClasses.focused} {
    background-color: ${theme.palette.mode === 'dark' ? '#003b57' : '#e6f7ff'};
    cursor: pointer;

    & svg {
      color: currentColor;
    }
  }
`
);

export const areAllElementsPresent = (a:any, b:any) =>
{
	return b.every((ele:any) => a.includes(ele));
};

export const updateArrKeyValues = (arr:any, id:any, obj:any, Objkey:any) =>
{
	const newArr:any = [ ...arr ];

	const updateArr:any = newArr?.map((each:any) =>
	{
		if (each[Objkey] === id)
		{
			return { ...each, ...obj };
		}

		return each;
	});

	return updateArr;
};

export const numberToRoman = (num, lowerCase = false) =>
{
	const romanNumeralsCaps = [
		{ value: 1000, numeral: 'M' },
		{ value: 900, numeral: 'CM' },
		{ value: 500, numeral: 'D' },
		{ value: 400, numeral: 'CD' },
		{ value: 100, numeral: 'C' },
		{ value: 90, numeral: 'XC' },
		{ value: 50, numeral: 'L' },
		{ value: 40, numeral: 'XL' },
		{ value: 10, numeral: 'X' },
		{ value: 9, numeral: 'IX' },
		{ value: 5, numeral: 'V' },
		{ value: 4, numeral: 'IV' },
		{ value: 1, numeral: 'I' }
	];

	const romanNumeralsSmall = [
		{ value: 1000, numeral: 'm' },
		{ value: 900, numeral: 'cm' },
		{ value: 500, numeral: 'd' },
		{ value: 400, numeral: 'cd' },
		{ value: 100, numeral: 'c' },
		{ value: 90, numeral: 'xc' },
		{ value: 50, numeral: 'l' },
		{ value: 40, numeral: 'xl' },
		{ value: 10, numeral: 'x' },
		{ value: 9, numeral: 'ix' },
		{ value: 5, numeral: 'v' },
		{ value: 4, numeral: 'iv' },
		{ value: 1, numeral: 'i' }
	];

	let result = '';

	for (const { value, numeral } of lowerCase ? romanNumeralsSmall : romanNumeralsCaps)
	{
		while (num >= value)
		{
			result += numeral;
			num -= value;
		}
	}

	return result;
};

export const convertMillisecondsToMMSS = (milliseconds) =>
{
	const getDuration = (val:any) =>
	{
		return String(Math.floor(val)).padStart(2, '0');
	};
	const seconds = Math.floor(milliseconds / 1000);

	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;

	const formattedMinutes = getDuration(minutes);
	const formattedSeconds = getDuration(remainingSeconds);

	const formattedTime = `${formattedMinutes}:${formattedSeconds}`;

	return formattedTime;
};

export const handleEncrypt = async (token:any, IdentityId:any) =>
{
	const CryptoJS = require('crypto-js');

	const authKey = 'kvqIjjRXFygP8A7dHmvnJm0HIhdY8rLD';
	const encryptD = {
		token,
		IdentityId
	};
	const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(encryptD), authKey).toString();

	return ciphertext;
};

export const authenticateApi = async (endPoint:any, path:any, headers:any, body:any, mobType:any) =>
{
	try
	{
		const res = await API.post(endPoint, path, {
			headers,
			body
		});

		return res;
	}
	catch (err)
	{
		console.log(err, '----------------err');

		return false;
	}
};

const readFileData = (file) =>
{
	return new Promise((resolve, reject) =>
	{
		const reader = new FileReader();

		reader.onload = (e:any) =>
		{
			resolve(e.target.result);
		};
		reader.onerror = (err) =>
		{
			reject(err);
		};
		reader.readAsDataURL(file);
	});
};

export const convertPdfToImages = async (file) =>
{
	let pdfFile:any = await fetch(file);

	pdfFile = await pdfFile.blob();

	const images:any = [];
	const data = await readFileData(pdfFile);
	const pdf = await PDFJS.getDocument(data).promise;
	const canvas = document.createElement('canvas');

	for (let i = 0; i < pdf.numPages; i++)
	{
		const page = await pdf.getPage(i + 1);
		const viewport = page.getViewport({ scale: 2.5 });
		const context = canvas.getContext('2d');

		canvas.height = viewport.height;
		canvas.width = viewport.width;
		await page.render({ canvasContext: context, viewport })
			.promise;
		images.push(canvas.toDataURL());
	}
	canvas.remove();

	return images;
};

// export const convertPdfToImages = async (pdfUrl) =>
// {
// 	try
// 	{
// 		// Fetch PDF document
// 		const loadingTask = pdfjsLib.getDocument(pdfUrl);
// 		const pdf = await loadingTask.promise;

// 		const urls:any = [];

// 		const totalPage = pdf.numPages;
// 		// Iterate over each page

// 		for (let pageNum = 1; pageNum <= totalPage; pageNum++)
// 		{
// 			// Render page as image
// 			const page = await pdf.getPage(pageNum);
// 			const scale = 2; // Adjust scale as needed
// 			const viewport = page.getViewport({ scale });
// 			const canvas = document.createElement('canvas');
// 			const context = canvas.getContext('2d');

// 			canvas.width = viewport.width;
// 			canvas.height = viewport.height;
// 			const renderContext:any = {
// 				canvasContext : context,
// 				viewport
// 			};

// 			await page.render(renderContext).promise;

// 			// Convert canvas to data URL
// 			const imageUrl = canvas.toDataURL('image/png');

// 			// Add image URL to array
// 			urls.push(imageUrl);
// 		}

// 		return urls;
// 	}
// 	catch (error)
// 	{
// 		console.error('Error:', error);
// 	}
// };

// export const convertPdfToImages = async (pdfUrl) =>
// {
// 	try
// 	{
// 		// Fetch PDF document
// 		const loadingTask = pdfjsLib.getDocument(pdfUrl);
// 		const pdf = await loadingTask.promise;

// 		const urls:any = [];

// 		const totalPage = pdf.numPages;
// 		// Iterate over each page

// 		for (let pageNum = 1; pageNum <= totalPage; pageNum++)
// 		{
// 			// Render page as image
// 			const page = await pdf.getPage(pageNum);
// 			const scale = 2; // Adjust scale as needed
// 			const viewport = page.getViewport({ scale });
// 			const canvas = document.createElement('canvas');
// 			const context = canvas.getContext('2d');

// 			canvas.width = viewport.width;
// 			canvas.height = viewport.height;
// 			const renderContext = {
// 				canvasContext : context,
// 				viewport
// 			};

// 			await page.render(renderContext).promise;

// 			// Convert canvas to data URL
// 			const imageUrl:any = canvas.toDataURL('image/png');

// 			// Add image URL to array
// 			urls.push(imageUrl);
// 		}

// 		return urls;
// 	}
// 	catch (error)
// 	{
// 		console.error('Error:', error);
// 	}
// };

export const checkRepetition = (a, b) =>
{
	let error = false;

	for (let i = 0; i < b.length; i++)
	{
		const count = a.filter((item) => item === b[i]).length;

		if (count > 1)
		{
			error = true;
		}
	}

	return error;
};

export const duplicateValuesInArr = (a:any) =>
{
	const hasDuplicates = new Set(a).size !== a.length;

	return hasDuplicates;
};

export const dateDiff = (dateFuture: number, dateNow: number, language?: any) =>
{
	const diffInMilliSeconds = Math.abs(dateFuture - dateNow);
	const days = Math.floor(diffInMilliSeconds / 86400000);
	const minutes = Math.floor(diffInMilliSeconds / 60000);

	const getTimeMessage = (value: number, singular: string, plural: string) =>
	{
		return value > 1 ? `${value} ${plural}` : `${value} ${singular}`;
	};

	if (days === 0)
	{
		if (minutes > 59)
		{
			const hours = Math.floor(minutes / 60);

			return getTimeMessage(hours, 'hrAgo', 'hrsAgo');
		}

		return minutes > 0
			? getTimeMessage(minutes, 'minuteAgo', 'minsAgo')
			: language?.justAgo;
	}

	if (days >= 365)
	{
		const years = Math.floor(days / 365);

		return getTimeMessage(years, 'yearAgo', 'yearsAgo');
	}

	if (days >= 30)
	{
		const months = Math.floor(days / 30);

		return getTimeMessage(months, 'monthAgos', 'monthsAgo');
	}

	return getTimeMessage(days, 'dayAgo', 'daysAgo');
};
export const removeSpaceFromArrayOfStrings = (arr:any) =>
{
	const newArr:any = [ ...arr ];

	const updatedArr:any = newArr?.map((str:any) => str?.trim());

	return updatedArr;
};
export const removeSpaceFromArrayOfObjects = (arrObj:any, key:any) =>
{
	const newArr:any = [ ...arrObj ];

	const updatedArr = newArr.map((obj:any) => ({
		...obj,
		[key] : obj[key].trim()
	}));

	return updatedArr;
};
export const dateMonthYear = (data) =>
{
	const date = new Date(data);

	// Get the day, month, and year
	const day = date.getDate();
	const month = date.toLocaleString('default', { month: 'short' }); // Short month name
	const year = date.getFullYear();

	// Construct the date string
	return `${day} ${month} ${year}`;
};

// export function getObjectWithLanguage(obj:any, lang:any)
// {
// 	console.log('objjjjjjjjjjj', obj, 'lang', lang);
// 	const newObj:any = {};

// 	for (const key in obj)
// 	{
// 		if (obj.hasOwnProperty(key))
// 		{
// 			newObj[key] = obj[key][lang];
// 		}
// 	}
// 	console.log('newObj', newObj);

// 	return newObj;
// }

export function getObjectWithLanguage(lang:any)
{
	const multipleLanguagesObject: any = {
		en,
		hi,
		sp,
		it,
		fr,
		pt
	};

	return multipleLanguagesObject[lang];
}

export const updatedKeysData = (initialObj, currentObj) =>
{
	const updatedFields = {};

	Object.keys(currentObj).forEach((key) =>
	{
		if (initialObj[key] !== currentObj[key])
		{
			updatedFields[key] = currentObj[key];
		}
	});

	return updatedFields;
};

export const stringToUint8Array = (str:any) =>
{
	const strArray = str.split(',');
	const numArray = strArray.map(Number);
	const uint8Array = new Uint8Array(numArray);

	return uint8Array;
};

// export const compressObject = (obj) =>
// {
//  const compressed = pako.deflate(JSON.stringify(obj));

//  return btoa(compressed);
// };

// export const decompressObject = (compressedBase64) =>
// {
//  compressedBase64 = atob(compressedBase64);
//  compressedBase64 = stringToUint8Array(compressedBase64);
//  const obj = JSON.parse(pako.inflate(compressedBase64, { to: 'string' }));

//  return obj;
// };

export const compressObject = (obj:any) =>
{
	const jsonString = JSON.stringify(obj);
	const compressedData:any = pako.gzip(jsonString);

	return btoa(String.fromCharCode.apply(null, compressedData));
};

export const decompressObject = (compressedString:any) =>
{
	// Handle null, undefined, or empty string cases
	if (!compressedString || compressedString === 'undefined' || compressedString === 'null')
	{
		return {};
	}

	let jsonString:any;

	try
	{
		const compressedData = Uint8Array.from(atob(compressedString), (c) => c.charCodeAt(0));

		jsonString = pako.ungzip(compressedData, { to: 'string' });
	}
	catch (err) // #I5239 for old files which were saved as stringified objects
	{
		jsonString = compressedString;
	}

	try
	{
		return JSON.parse(jsonString);
	}
	catch (parseError)
	{
		console.warn('Failed to parse JSON in decompressObject:', parseError);
		return {};
	}
	// return jsonString;
};

export const compressFile = (file) =>
{
	return new Promise((resolve, reject) =>
	{
		new Compressor(file, {
			quality : 0.4,
			success : (result) =>
			{
				resolve(result);
			},
			error : (error) =>
			{
				reject(error);
			}
		});
	});
};

export const resizeFile = (file) =>
{
	return new Promise((resolve) =>
	{
		Resizer.imageFileResizer(
			file,
			Number(process.env.REACT_APP_IMG_WIDTH),
			Number(process.env.REACT_APP_IMG_HEIGHTT),
			'image/x-png,image/gif,image/jpeg,image/jpg,image/png,image/*',
			Number(process.env.REACT_APP_IMG_QUALITY),
			0,
			(uri) =>
			{
				resolve(uri);
			},
			'base64'
		);
	});
};

export function getMediaType(mimeType: string): string
{
	switch (mimeType.split('/')[0])
	{
		case ('application'):
		case ('text'):
			return 'document';
		case ('image'):
			return 'image';
		case ('video'):
			return 'video';
		default:
			return 'unknown';
	}
	// if (mimeType.startsWith('image/'))
	// {
	// 	return 'image';
	// }
	// else if (mimeType === 'application/pdf')
	// {
	// 	return 'pdf';
	// }
	// else if (
	// 	mimeType === 'application/msword' || // .doc
	// mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
	// )
	// {
	// 	return mimeType === 'application/msword' ? 'doc' : 'docx';
	// }
	// else
	// {
	// 	return 'unknown';
	// }
}

// export const arraysEqual = (arr1: string[], arr2: string[]): boolean =>
// {
// 	if (arr1.length !== arr2.length) return false;
// 	for (let i = 0; i < arr1.length; i++)
// 	{
// 		if (arr1[i] !== arr2[i]) return false;
// 	}

// 	return true;
// };

// export const updateBodyKey = (initialObj, currentObj) =>
// {
// 	const updatedFields = {};

// 	// Iterate over the keys in currentObj
// 	for (const key of Object.keys(currentObj))
// 	{
// 		const initialValue = initialObj[key];
// 		const currentValue = currentObj[key];

// 		// Check if both values are arrays
// 		if (Array.isArray(initialValue) && Array.isArray(currentValue))
// 		{
// 			if (!arraysEqual(initialValue, currentValue))
// 			{
// 				updatedFields[key] = currentValue;
// 			}
// 		}
// 		// Check if values are different (includes array vs non-array)
// 		else if (initialValue !== currentValue)
// 		{
// 			updatedFields[key] = currentValue;
// 		}
// 	}

// 	return updatedFields;
// };

export const arraysEqual = (arr1: string[], arr2: string[]): boolean =>
{
	if (arr1.length !== arr2.length) return false;
	for (let i = 0; i < arr1.length; i++)
	{
		if (arr1[i] !== arr2[i]) return false;
	}

	return true;
};

export const updateBodyKey = (initialObj: Record<string, any>, currentObj: Record<string, any>) =>
{
	const updatedFields: Record<string, any> = {};

	// Iterate over the keys in currentObj
	for (const key of Object.keys(currentObj))
	{
		const initialValue = initialObj[key];
		const currentValue = currentObj[key];

		if (Array.isArray(initialValue) && Array.isArray(currentValue))
		{
		// Check if both are arrays and not equal
			if (!arraysEqual(initialValue, currentValue))
			{
				updatedFields[key] = currentValue;
			}
		}
		else if (typeof initialValue === 'object' && typeof currentValue === 'object' && initialValue && currentValue)
		{
		// Check if both are objects and not null
			const nestedUpdates = updateBodyKey(initialValue, currentValue); // Recursive call for nested objects

			if (Object.keys(nestedUpdates).length > 0)
			{
				updatedFields[key] = nestedUpdates;
			}
		}
		else if (initialValue !== currentValue)
		{
		// Check if values are different (includes array vs non-array or primitives)
			updatedFields[key] = currentValue;
		}
	}

	return updatedFields;
};
export const findRemovedObjects = (initialArray, currentArray, key) =>
{
	return initialArray.filter((initialObj) =>
		!currentArray.some((currentObj) => currentObj[key] === initialObj[key])
	);
};

const daysOfWeek = [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ];

const timeFormatters = {
	day   : (date) => daysOfWeek[date.getDay()],
	date  : (date) => date.getDate(),
	hours : (date) =>
	{
		const hours = date.getHours() % 12;

		return hours === 0 ? 12 : hours;
	},
	minutes : (date) =>
	{
		const minutes = date.getMinutes();

		return minutes < 10 ? `0${minutes}` : minutes;
	},
	noon : (date) => (date.getHours() > 12 ? 'PM' : 'AM')
};

export const formatTimeValue = (type, timeStamp) =>
{
	const date = new Date(timeStamp);
	const formatter = timeFormatters[type];

	if (formatter)
	{
		return formatter(date);
	}
};

export function getWeekDayAndDate(date)
{
	// Get the day of the week (0-6) where 0 is Sunday and 6 is Saturday
	const weekDayIndex = date.getDay();

	// Array to convert the index to the abbreviated name of the day
	const weekDays = [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ];
	const weekDay = weekDays[weekDayIndex];

	// Get the date of the month (1-31)
	const dayOfMonth = date.getDate();

	return { weekDay, dayOfMonth };
}

export const StartEndDur = (date) =>
{
	let hours = date.getHours();
	let minutes = date.getMinutes();
	const ampm = hours >= 12 ? 'PM' : 'AM';

	hours = hours % 12; // Convert to 12-hour format
	hours = hours || 12;
	hours = hours > 9 ? hours : `0${hours}`;
	minutes = minutes > 9 ? minutes : `0${minutes}`;

	return { hours, minutes, ampm };
};

export const toHoursAndMinutes = (totalMilliseconds) =>
{
	const totalMinutes = totalMilliseconds / 60000;

	const hours = Math.floor(totalMinutes / 60);
	const minutes = Math.floor(totalMinutes % 60);

	// Format hours and minutes to ensure two digits
	const formattedHours = hours >= 10 ? `${hours}` : `0${hours}`;
	const formattedMinutes = minutes >= 10 ? `${minutes}` : `0${minutes}`;

	return { formattedHours, formattedMinutes };
};

export function formatTimeAMPM(timestamp)
{
	const date = new Date(timestamp);
	let hours = date.getHours();
	const minutes = date.getMinutes();
	const period = hours >= 12 ? 'PM' : 'AM';

	// Convert to 12-hour format
	hours = hours % 12;
	hours = hours || 12; // The hour '0' should be '12'

	// Format time as 'HH:MM AM/PM'
	return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;
}

export function calculateDuration(startTimestamp, endTimestamp)
{
	if (endTimestamp < startTimestamp)
	{
		return '00:00';
	}
	// Calculate the difference in milliseconds
	const diffMs = endTimestamp - startTimestamp;

	// Convert milliseconds to minutes
	const diffMinutes = diffMs / 60000;

	// Convert total minutes into hours and minutes
	const hours = Math.floor(diffMinutes / 60);
	const minutes = Math.floor(diffMinutes % 60);

	// Format hours and minutes as two-digit numbers
	const formattedHours = hours.toString().padStart(2, '0');
	const formattedMinutes = minutes.toString().padStart(2, '0');

	// Return formatted duration
	return `${formattedHours} hr : ${formattedMinutes} Min`;
}

export function generateRandomFourDigitNumber()
{
	let randomNumber:any = '';

	for (let i = 0; i < 6; i++)
	{
		randomNumber += Math.floor(Math.random() * 10); // Generates a digit between 0 and 9
	}

	return randomNumber;
}

export function capitalizeFirstLetter(name:string = '')
{
	if (name) return name[0].toUpperCase() + name.slice(1).toLowerCase();
	else return '';
}
export function formatDate(date)
{
	const options:any = {
		month  : 'short',
		day    : 'numeric',
		hour   : 'numeric',
		minute : 'numeric',
		hour12 : true
	};

	return new Intl.DateTimeFormat('en-US', options).format(date);
}

export function formatDateWithSuffix(num)
{
	const suffix = [ 'th', 'st', 'nd', 'rd' ][(num % 10 > 3 || ~~(num % 100 / 10) === 1) ? 0 : num % 10];

	return suffix;
}

export function formatDateWeekMonthDateYear(date:Date)
{
	const dateOptions: Intl.DateTimeFormatOptions = {
		weekday : 'long',
		year    : 'numeric',
		month   : 'long',
		day     : 'numeric'
	};
	const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);

	return formattedDate;
}
export const compressImage = async (file, quality, targetSize) =>
{
	return new Promise((resolve, reject) =>
	{
		const attemptCompression = (currentQuality) =>
		{
			new Compressor(file, {
				quality : currentQuality,
				success : (result) =>
				{
					if (result?.size <= targetSize || currentQuality <= 0.05)
					{
						resolve(result);
					}
					else
					{
						attemptCompression(currentQuality - 0.05);
					}
				},
				error : (err) =>
				{
					resolve(file);
					// reject(err);
				}
			});
		};

		attemptCompression(quality);
	});
};
export const compressToTargetSize = async (file, quality) =>
{
	// const targetSize = 100 * 1024; // 100 KB in bytes // image is greater than 1.5 mb then 17 percent

	const targetSize = file?.size <= 1.5 * 1024 * 1024 ? 250 * 1024 : Math.floor(file?.size * 0.17);

	if (!file.type.includes('jpeg') && !file.type.includes('jpg'))
	{
		const blob = file instanceof Blob ? file : file.slice();// creating a new Blob

		const fileName = file.name.replace(/\.[^/.]+$/, '.jpg');
		const jpegFile = new File([ blob ], fileName, { type: 'image/jpeg' });

		const compressedImage = await compressImage(jpegFile, quality, targetSize);

		return compressedImage;

		// return await compressImage(jpegFile, quality, targetSize);
	}
	else
	{
		const compressedImage = await compressImage(file, quality, targetSize);

		return compressedImage;
	}
};

export function generateThumbnailFromVideo(file)
{
	return new Promise((resolve, reject) =>
	{
		const videoEle = document.createElement('video');

		videoEle.src = URL.createObjectURL(file);
		videoEle.addEventListener('loadeddata', () =>
		{
			if (videoEle?.duration > 5)
			{
				videoEle.currentTime = 5;
			}
			else
			{
				videoEle.currentTime = videoEle?.duration / 2;
			}
		});
		videoEle.addEventListener('seeked', async () =>
		{
			const canvas = document.createElement('canvas');

			setTimeout(async () =>
			{
				canvas.width = videoEle.videoWidth;
				canvas.height = videoEle.videoHeight;

				const context = canvas.getContext('2d');

				context?.drawImage(videoEle, 0, 0, canvas.width, canvas.height);

				const thumbnailImg = canvas.toDataURL('image/jpeg', 0.9);

				const blob = dataURLtoFile(thumbnailImg, file.name);

				try
				{
					const qualityD = 0.8;
					const fileC:any = await compressToTargetSize(blob, qualityD);

					const fileT = new File([ fileC ], fileC.name, { type: fileC.type });

					resolve({
						thumbnailFile : fileT,
						width         : canvas?.width,
						height        : canvas?.height
					});
				}
				catch (err)
				{
					console.log('compres err');
					reject(err);
				}
			}, 100);

			// const File = await objectUrlToFile(thumbnailImg, file?.name);

			// resolve(File);
		});
		videoEle.addEventListener('error', (err) =>
		{
			reject(err);
		});
	}
	);
}

export const getBlobUrl = async (key) =>
{
	console.log(key, '------------------key');
	Storage.configure({
		bucket       : process.env.REACT_APP_S3_BUCKET,
		customPrefix : {
			public : ''
		},
		region : process.env.REACT_APP_S3_BUCKET_REGION
	});

	try
	{
		const result:any = await Storage.get(key, { download: true });

		const url:any = await URL.createObjectURL(result?.Body);

		console.log(url, '-------------url');

		return url;
	}
	catch (err)
	{
		console.log(err);

		return '';
	}
};

export const updateImgInS3 = async (key, file, path) =>
{
	Storage.configure({
		bucket : process.env.REACT_APP_S3_BUCKET,
		region : process.env.REACT_APP_S3_BUCKET_REGION
	});

	// const sanitizedKey = sanitizeFileName(key);

	try
	{
		const uploadToS3:any = await Storage.put(key, file, {
			contentType  : file?.type,
			customPrefix : {
				public : `${path}`
			}
		});

		return uploadToS3;
	}
	catch (err)
	{
		console.log(err);

		return err;
	}
};

export const isValidDate = (date) => // validate if date is a valid object
{
	return !isNaN(date) && date instanceof Date;
};

export const generateThumbnailFrmUtube = (youtubeUrl) =>
{
	const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^&\n]{11})/;
	const matches = youtubeUrl?.match(regex);

	try
	{
		if (matches && matches[1])
		{
			const videoId = matches[1];

			return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
		}
		else
		{
			console.log('---err-------------');
		}
	}
	catch (err)
	{
		console.log('Invalid YouTube URL');
	}
};

export const getDataUrlFrmLocalSystm = async (imagePath) =>
{
	const response:any = await fetch(imagePath);
	const blob = await response.blob();

	return new Promise((resolve, reject) =>
	{
		const reader = new FileReader();

		reader.onloadend = () =>
		{
			const dataUrl = reader.result;

			resolve(dataUrl);
		};

		reader.onerror = () =>
		{
			reject(new Error('Failed to read the file as Data URL'));
		};

		reader.readAsDataURL(blob);
	});
};

export const configureStore = async (thumbnailFile, prefix) =>
{
	Storage.configure({
		bucket : process.env.REACT_APP_S3_BUCKET,
		region : process.env.REACT_APP_S3_BUCKET_REGION
	});
	// const customPrefix = { public: `${userData?.companyId}/feed/` };

	const newKey = `${Date.now()}_thumbnail.jpeg`;

	const result = await Storage.put(newKey, thumbnailFile, {
		customPrefix : prefix,
		contentType  : thumbnailFile?.type
	});

	return (`${process.env.REACT_APP_S3_BASE_URL}/${prefix?.public}${result.key}`);
};

export const handleThumbnail = async (fileT, prefixC) =>
{
	const qualityD = 0.80;

	try
	{
		const compressedFile = await compressToTargetSize(fileT, qualityD);

		const thumbnail = await configureStore(compressedFile, prefixC);

		return thumbnail;
	}
	catch (error)
	{
		console.log(error, '---------------');
	}
};

export const convertDOMToImage = async (element) =>
{
	try
	{
		if (!element)
		{
			console.error('No element found to convert to image');

			return null;
		}

		const options = {
			useCORS      : true,
			scale        : 2,
			logging      : false,
			allowTaint   : true,
			imageTimeout : 15000
		};

		// Convert DOM to canvas
		const canvas = await html2canvas(element, options);
		// Convert canvas to image data URL
		const imageDataUrl = canvas.toDataURL('image/png');
		// Generate a unique filename
		const filename = `occasion_image_${Date.now()}.png`;
		const fileData = dataURLtoFile(imageDataUrl, filename);

		return fileData;
	}
	catch (error)
	{
		console.error('-----------dom', error);

		return null;
	}
};

export const getFullAddress = (address) =>
{
	if (!address || (typeof address === 'object' && Object.keys(address).length === 0)) return false;
	else if (typeof address === 'string') return address;
	else return [ address?.address, address?.city, address?.stateName, address?.countryName, address?.pincode ].filter((item) => item).join(', ');
};

export const getFullNumber = (countryCode, number) =>
{
	if (!number) return '';
	let phoneNumber = `+${countryCode} ${number}`;

	if (number?.includes('+'))
	{
		phoneNumber = number;
	}
	else if ((countryCode)?.includes('+'))
	{
		phoneNumber = `${countryCode} ${number}`;
	}

	return phoneNumber;
};

export const getNewImageDim = (image: HTMLElement, item) =>
{
	const imageHeight = image?.offsetHeight;
	const imageWidth = image?.offsetWidth;

	const canvasHeight = item?.dimensions?.height;
	const canvasWidth = item?.dimensions?.width;

	const heightRatio = canvasHeight / imageHeight;
	const widthRatio = canvasWidth / imageWidth;

	// byWidth
	let newWidth = 0;
	let newHeight = 0;

	newWidth = imageWidth * widthRatio;
	newHeight = imageHeight * widthRatio;

	// byHeight
	if (newWidth > canvasWidth || newHeight > canvasHeight)
	{
		newWidth = imageWidth * heightRatio;
		newHeight = imageHeight * heightRatio;
	}

	const xPos = (canvasWidth - newWidth) / 2;
	const yPos = (canvasHeight - newHeight) / 2;

	return { newWidth, newHeight, xPos, yPos };
};

export const truncateHTML = (htmlContent, limit) =>
{
	const div = document.createElement('div');

	div.innerHTML = htmlContent;

	let charCount = 0;
	const truncateNode = (node) =>
	{
		if (charCount >= limit) return null;

		if (node.nodeType === Node.TEXT_NODE)
		{
			const remainingChars = limit - charCount;
			const text = node.textContent || '';

			if (text.length > remainingChars)
			{
				charCount += remainingChars;

				return document.createTextNode(`${text.slice(0, remainingChars)}...`);
			}
			else
			{
				charCount += text.length;

				return node.cloneNode(true);
			}
		}

		if (node.nodeType === Node.ELEMENT_NODE)
		{
			const clonedNode = node.cloneNode(false);

			for (const childNode of node.childNodes)
			{
				const truncatedChild = truncateNode(childNode);

				if (!truncatedChild) break;
				clonedNode.appendChild(truncatedChild);
			}

			return clonedNode;
		}

		return null;
	};

	const resultNode = truncateNode(div);

	return resultNode ? resultNode.innerHTML : '';
};

export const currentMonthStartTime = () =>
{
	const now = new Date();
	const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

	return startOfMonth.getTime();
};

export const durationFormate = (hours) =>
{
	const totalMinutes = Math.round(hours * 60);

	const hr = Math.floor(totalMinutes / 60);
	const min = totalMinutes % 60;

	if (hr > 0)
	{
		return `${hr} hrs ${min} mins`;
	}
	else
	{
		return `${min} mins`;
	}
};

export const getTextFromHTML = (htmlTag) =>
{
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlTag ?? '', 'text/html');
	const text:any = doc.body.textContent?.trim();

	return text;
};

export const decryptPresenceToken = async (token) =>
{
	const CryptoJS = require('crypto-js');

	try
	{
		const decryptedToken = await CryptoJS.AES.decrypt(decodeURIComponent(token), process.env.REACT_APP_PRESENCE_AUTH_TOKEN_DECRYPT_KEY).toString(CryptoJS.enc.Utf8);

		return decryptedToken;
	}
	catch (err)
	{
		return '';
	}
};
export const copyFilesTos3 = async (folder) =>
{
	Storage.configure({
		bucket       : process.env.REACT_APP_S3_BUCKET,
		region       : process.env.REACT_APP_S3_BUCKET_REGION,
		customPrefix : {
			public : ''
		}
	});

	const key = folder?.key;
	const destinationKey = key?.split('/')[1];
	const replaceKeyname = key?.replace(destinationKey, 'collaboration');

	const lastIndex = replaceKeyname?.lastIndexOf('/');

	const newKey = `${replaceKeyname?.substring(0, lastIndex)}/${new Date().valueOf()}${folder?.name}`;
	// const customPrefix = { public: `${userData?.companyId}/feed/` };

	const copiedObj:any = await Storage.copy({ key }, { key: newKey });

	const newObj = {
		url   : `${process.env.REACT_APP_S3_BASE_URL}/${copiedObj?.key}`,
		type  : folder?.type,
		key   : copiedObj?.key,
		title : copiedObj?.key.split('/')?.pop(),
		name  : folder?.name,
		size  : folder?.size
	};

	return newObj;
};

export const copyToClipboard = (text, successMessage, blockRef) =>
{
	if (navigator.clipboard)
	{
		navigator.clipboard
			.writeText(text)
			.then(() =>
			{
				// toast.success(language?.youHaveCopiedSuccessfully,
				toast.success(successMessage,
					{
						position : toast.POSITION.TOP_RIGHT
					});
			})
			.catch((error) =>
			{
				// eslint-disable-next-line no-console
				console.log(error);
			});
	}
	else
	{
		const textarea = document.createElement('textarea');

		textarea.value = text;
		document.body.appendChild(textarea);
		textarea.select();
		document.execCommand('copy');
		document.body.removeChild(textarea);
		blockRef.current = true;
	}

	setTimeout(() =>
	{
		blockRef.current = false;
	}, 5000);
};

export const getTimeDifference = (createdAt) =>
{
	const timeoutDuration = 40000;

	const elapsedTime = Date.now() - createdAt;
	const remainingTime = Math.max(timeoutDuration - elapsedTime, 0);

	return remainingTime;
};

export	const base64ToBlob = (base64String, name) =>
{
	const base64Data = base64String.split(',')[1] || base64String;

	const byteCharacters = atob(base64Data);
	const byteNumbers = new Array(byteCharacters.length);

	for (let i = 0; i < byteCharacters.length; i++)
	{
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}

	const byteArray = new Uint8Array(byteNumbers);

	return new File([ byteArray ], name ?? 'file.png', { type: 'image/png' });
};

export const compareObjData = (obj1, obj2) =>
{
	// Quick reference and type checks
	if (obj1 === obj2) return false; // If both are exactly the same, no changes exist.

	// Check for null or undefined
	if (obj1 == null || obj2 == null) return obj1 !== obj2; // If one is null and the other isn't, return true.

	// Type and constructor checks
	const type1 = typeof obj1;
	const type2 = typeof obj2;

	if (type1 !== type2) return true; // If types differ, return true.

	// Handle Date objects
	if (obj1 instanceof Date)
	{
		return !(obj2 instanceof Date && obj1.getTime() === obj2.getTime()); // If dates are not the same, return true.
	}

	// Handle RegExp objects
	if (obj1 instanceof RegExp)
	{
		return !(obj2 instanceof RegExp && obj1.source === obj2.source && obj1.flags === obj2.flags); // If RegExps differ, return true.
	}

	// Stack for iterative comparison
	const stack:any = [ { a: obj1, b: obj2, path: [] } ];

	// Track visited objects to prevent circular reference issues
	const visited = new WeakMap();

	while (stack.length > 0)
	{
		const { a, b, path } = stack.pop();

		// Quick reference check
		if (a === b) continue;

		// Ensure only objects are added to WeakMap
		if (typeof a === 'object' && a !== null)
		{
			if (visited.has(a) && visited.get(a) === b) continue;
			visited.set(a, b);
		}

		// Type checks
		if (a == null || b == null)
		{
			if (a !== b) return true; // If one is null and the other isn't, return true.
			continue;
		}

		const typeA = typeof a;
		const typeB = typeof b;

		if (typeA !== typeB) return true; // If types don't match, return true.

		// Handle primitive types
		if (typeA !== 'object' && typeA !== 'function')
		{
			if (a !== b) return true; // If primitive values differ, return true.
			continue;
		}

		// Array comparison
		if (Array.isArray(a))
		{
			if (!Array.isArray(b) || a.length !== b.length) return true; // If arrays differ in type or length, return true.

			// Push array elements to stack for comparison
			for (let i = a.length - 1; i >= 0; i--)
			{
				stack.push({
					a    : a[i],
					b    : b[i],
					path : [ ...path, i ]
				});
			}
			continue;
		}

		// Object comparison
		if (typeA === 'object')
		{
			const keysA = Object.keys(a);
			const keysB = Object.keys(b);

			// Quick key length check
			if (keysA.length !== keysB.length) return true; // If number of keys differ, return true.

			// Push object properties to stack
			for (const key of keysA)
			{
				// Check key existence
				if (!(key in b)) return true; // If a key is missing in b, return true.

				stack.push({
					a    : a[key],
					b    : b[key],
					path : [ ...path, key ]
				});
			}
			continue;
		}

		// Function comparison (reference check)
		if (typeA === 'function')
		{
			if (a !== b) return true; // If function references differ, return true.
		}
	}

	return false; // If no differences are found, return false.
};

export const callTimerFormat = (duration: number) =>
{
	const hours = Math.floor(duration / 3600);
	const minutes = Math.floor((duration % 3600) / 60);
	const seconds = duration % 60;

	// Format time based on duration
	let formattedTime;

	if (hours > 0)
	{
		formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
	}
	else
	{
		formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
	}

	return formattedTime;
};

export const redirectToCognitoSignOut = async () =>
{
	// const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;
	// const clientId = process.env.REACT_APP_APP_CLIENT_ID;
	// const redirectUri = window.location.origin;

	// const signOutUrl = `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${redirectUri}`;

	// window.location.href = signOutUrl;
	await Auth.signOut();
};

export const isInlynkGroupMissing = async (bypassCache = false) =>
{
	try
	{
		bypassCache = JSON.parse(new URLSearchParams(window.location.search).get('bypassCache') || 'false') || bypassCache;
	}
	catch (err)
	{
		bypassCache = false;
	}

	// if user does not have inLynk in cognito group then
	// need to signout user and redirect to login

	try
	{
		return false;
		// Get the current authenticated user
		// const user = await Auth.currentAuthenticatedUser({ bypassCache });
		// // const user = await Auth.currentAuthenticatedUser();

		// // The user's Cognito groups are available in the user session
		// const currentUser = user.getSignInUserSession();
		// const idToken = currentUser.getIdToken();
		// const payload = idToken.decodePayload();

		// // Cognito groups are stored in the 'cognito:groups' claim in the ID token
		// const userGroups = payload['cognito:groups'] || [];

		// console.log('userGroups****', bypassCache, userGroups);

		// // Check if the user belongs to the specified group
		// return !userGroups.includes('inLynk');
	}
	catch (error)
	// eslint-disable-next-line no-unreachable
	{
		// eslint-disable-next-line no-console
		console.error('Error checking user group membership:', error);
		throw error;
	}
};

interface DownloadFileItem {
    url?: string;
    audioUrl?: string;
    coverImage?: string;
    title?: string;
    fileType?: string;
}

export const handleFileDownload = async (currentItem: DownloadFileItem): Promise<boolean> =>
{
	try
	{
		if (!currentItem) return false;

		// Get the file URL based on item type
		const fileUrl = currentItem.url || currentItem.audioUrl || currentItem.coverImage;

		if (!fileUrl)
		{
			console.error('No file URL available');

			return false;
		}

		// Get the file name from the URL or use the title
		let fileName = currentItem.title || 'download';

		const isDocument = currentItem.fileType && [ 'pdf', 'doc', 'docx', 'txt', 'rtf', 'odt', 'pages' ].includes(currentItem.fileType.toLowerCase());

		if (isDocument)
		{
			const extend = fileName.lastIndexOf('.');

			fileName = extend > 0 ? fileName.substring(0, extend) : fileName;
		}

		const fileExtension = currentItem.fileType || fileUrl.split('.').pop();

		// Extract S3 key from the URL
		const baseUrl = `${process.env.REACT_APP_S3_BASE_URL}/` || '';
		const s3Key = fileUrl.replace(baseUrl, ''); // Remove base URL and leading slashes

		if (!s3Key)
		{
			throw new Error('Invalid S3 key');
		}

		await Storage.configure({
			bucket       : process.env.REACT_APP_S3_BUCKET,
			region       : process.env.REACT_APP_S3_BUCKET_REGION,
			customPrefix : { public: '' }
		});

		// Download from S3
		const response = (await Storage.get(s3Key, {
			download : true
		}) as unknown) as { Body: Blob };

		// Create a download link
		const downloadUrl = window.URL.createObjectURL(response.Body);
		const link = document.createElement('a');

		link.href = downloadUrl;
		link.download = `${fileName}.${fileExtension}`;

		// Trigger download
		document.body.appendChild(link);
		link.click();

		// Cleanup
		document.body.removeChild(link);
		window.URL.revokeObjectURL(downloadUrl);

		return true;
	}
	catch (error)
	{
		console.error('Error downloading file:', error);

		return false;
	}
};

export const extractKeyFrmS3 = (url: string) =>
{
	const baseUrl = `${process.env.REACT_APP_S3_BASE_URL}/` || '';
	const s3Key = url.replace(baseUrl, '').replace(/^\//, ''); // Remove base URL and leading slashes

	return s3Key;
};

export const decodeBase64 = (value: string) =>
{
	try
	{
		return window.atob(value);
	}
	catch (error)
	{
		return value;
	}
};

export const convertSecondsToSpentTime = (seconds: number): string =>
{
	if (!seconds || seconds < 0) return '0s';

	const days = Math.floor(seconds / (24 * 3600));
	const hours = Math.floor((seconds % (24 * 3600)) / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = Math.floor(seconds % 60);

	const parts: string[] = [];

	if (days > 0)
	{
		parts.push(`${days}d`);
	}
	if (hours > 0)
	{
		parts.push(`${hours}h`);
	}
	if (minutes > 0)
	{
		parts.push(`${minutes}m`);
	}
	if (remainingSeconds > 0 || parts.length === 0)
	{
		parts.push(`${remainingSeconds}s`);
	}

	return parts.join(' ');
};
